/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonaleRapportinoUpdateDTO
 */
export interface PersonaleRapportinoUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    idPersonale?: number;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    dataDaMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    dataAMattino?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    dataDaPomeriggio?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    dataAPomeriggio?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    oreTotali?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    oreViaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    viaggio?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    pernottamenti?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    dataIntervento?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    idCommessa?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PersonaleRapportinoUpdateDTO
     */
    descrizioneCommessa?: string | null;
}

/**
 * Check if a given object implements the PersonaleRapportinoUpdateDTO interface.
 */
export function instanceOfPersonaleRapportinoUpdateDTO(value: object): value is PersonaleRapportinoUpdateDTO {
    return true;
}

export function PersonaleRapportinoUpdateDTOFromJSON(json: any): PersonaleRapportinoUpdateDTO {
    return PersonaleRapportinoUpdateDTOFromJSONTyped(json, false);
}

export function PersonaleRapportinoUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonaleRapportinoUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'dataDaMattino': json['dataDaMattino'] == null ? undefined : (new Date(json['dataDaMattino'])),
        'dataAMattino': json['dataAMattino'] == null ? undefined : (new Date(json['dataAMattino'])),
        'dataDaPomeriggio': json['dataDaPomeriggio'] == null ? undefined : (new Date(json['dataDaPomeriggio'])),
        'dataAPomeriggio': json['dataAPomeriggio'] == null ? undefined : (new Date(json['dataAPomeriggio'])),
        'oreTotali': json['oreTotali'] == null ? undefined : json['oreTotali'],
        'oreViaggio': json['oreViaggio'] == null ? undefined : json['oreViaggio'],
        'viaggio': json['viaggio'] == null ? undefined : json['viaggio'],
        'pernottamenti': json['pernottamenti'] == null ? undefined : json['pernottamenti'],
        'dataIntervento': json['dataIntervento'] == null ? undefined : (new Date(json['dataIntervento'])),
        'idCommessa': json['idCommessa'] == null ? undefined : json['idCommessa'],
        'descrizioneCommessa': json['descrizioneCommessa'] == null ? undefined : json['descrizioneCommessa'],
    };
}

export function PersonaleRapportinoUpdateDTOToJSON(json: any): PersonaleRapportinoUpdateDTO {
    return PersonaleRapportinoUpdateDTOToJSONTyped(json, false);
}

export function PersonaleRapportinoUpdateDTOToJSONTyped(value?: PersonaleRapportinoUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'dataDaMattino': value['dataDaMattino'] == null ? undefined : ((value['dataDaMattino'] as any).toISOString()),
        'dataAMattino': value['dataAMattino'] == null ? undefined : ((value['dataAMattino'] as any).toISOString()),
        'dataDaPomeriggio': value['dataDaPomeriggio'] == null ? undefined : ((value['dataDaPomeriggio'] as any).toISOString()),
        'dataAPomeriggio': value['dataAPomeriggio'] == null ? undefined : ((value['dataAPomeriggio'] as any).toISOString()),
        'oreTotali': value['oreTotali'],
        'oreViaggio': value['oreViaggio'],
        'viaggio': value['viaggio'],
        'pernottamenti': value['pernottamenti'],
        'dataIntervento': value['dataIntervento'] == null ? undefined : ((value['dataIntervento'] as any).toISOString()),
        'idCommessa': value['idCommessa'],
        'descrizioneCommessa': value['descrizioneCommessa'],
    };
}

